var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle"},[_c('input',{attrs:{"type":"checkbox","id":_vm.name},on:{"click":function($event){return _vm.$emit('click')}}}),_c('label',{attrs:{"for":_vm.name}},[_vm._v("Toggle")])])
}
var staticRenderFns = []

export { render, staticRenderFns }